
import { Box, ButtonBase, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { useState } from "react";

import { ArrowRightIcon } from "@mui/x-date-pickers";
import PopoverModal from "../Modal/PopoverModal";
import { useTranslation } from "react-i18next";
import Subheading from "../text/Subheading";
const ShRhDataGridSelectedActions = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();    

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;

    const handlePopoverClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <>
            <Box
                sx={{
                    ...props.sx,
                }}
            >

                <Box
                        sx={{
                            marginLeft:"auto",
                        }}
                >

                    <ButtonBase
                        aria-describedby={popoverId}
                        onClick={handlePopoverClick}
                        sx={{
                            height:40,
                            flexShrink:0,
                            // background:"orange",
                            borderRadius:6,
                            paddingLeft:3,
                            paddingRight:0.5,
                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200],
                            color:colors.txt['primary'],
                            fontWeight:"bold",
                            fontSize:"17",
                            fontFamily:"Roboto, sans-serif",
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",

                            "& .arrow" : {
                                transition:"250ms",
                            },
                            "&:hover" : {
                                "& .arrow" : {
                                    transition:"250ms",
                                    transform:"rotate(-90deg)"
                                },
                            },
                            "@media screen and (min-width:47.9375em)" :{
                                display:"none",
                            }
                        }}
                    >
                        {t("actions")}
                        <Box
                            className={"arrow"}
                            sx={{
                                marginLeft:2,
                                background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                                color:`${theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt['light']}`,
                                height:32,
                                width:32,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:5,
                            }}
                        >
                            <ArrowRightIcon/>
                        </Box>
                    </ButtonBase>
                    <Box
                        sx={{ 
                            
                            
                            "@media screen and (max-width:47.9375em)" :{
                                display:"none",
                            }
                        }}
                    >
                        {props.children}
                    </Box>
                </Box>
            </Box>
            
            <PopoverModal
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                transformOrigin={{
                    vertical:"bottom"
                }}
                anchorOrigin={{
                    vertical:"top"
                }}
                // {...props}
                triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
            >
                <Box 
                    sx={{
                        background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                        display:"flex",
                        flexDirection:"column",
                        borderRadius:"16px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,
                        minWidth:300,
                        "@media screen and (max-width: 48em)" : {
                            borderRadius:"32px",
                            borderTopLeftRadius:"12px",
                            borderTopRightRadius:"12px",
                            borderBottomLeftRadius:0,
                            borderBottomRightRadius:0,

                        }
                    }}
                >
                    <Box
                        sx={{
                            px:3,
                            py:3,
                            textAlign:"center",
                        }}
                    >
                        <Subheading>{t("actions")}</Subheading>
                    </Box>
                     <Box 
                        sx={{
                            background: theme.palette.mode === "dark" ? colors.grey[300] : "#fff",
                            padding:1.5,
                            paddingBottom: isStandAlone ? 4 : 1.5,
                            display:"flex",
                            gap:1,
                            flexDirection:"column",
                            borderRadius:"16px",
                            borderBottomLeftRadius:0,
                            borderBottomRightRadius:0,
                            minWidth:300,
                            "@media screen and (max-width: 48em)" : {
                                borderRadius:"32px",
                                borderTopLeftRadius:"12px",
                                borderTopRightRadius:"12px",
                                borderBottomLeftRadius:0,
                                borderBottomRightRadius:0,

                            }
                        }}
                    >
                        {props.children}
                    </Box>
                </Box>
               
            </PopoverModal>
        </>
    )
}

export default ShRhDataGridSelectedActions;